export const blockIconsPrivacyandsecurityE911EmergencyNew = (
	<span className='material-symbols-outlined'>e911_emergency</span>
);
